import {Component, OnInit, Input, ViewChild, Output, EventEmitter} from '@angular/core';
import { DialogRef } from '@progress/kendo-angular-dialog';
import { FormGroup, FormBuilder } from '@angular/forms';
import { PageSubheaderBarConfig } from '../../../fw/pages/page-config-api';
import { FormService } from '../../../fw/services/form.service';
import { SharedService } from '../../shared/shared.service';
import { AutoUnsubscribe } from '../../../fw/decoractors/AutoUnsubscribe';
import {SettingsCashregService} from "./settings-cashreg.service";
import {DynamicGridComponent} from "../../../fw/dynamic-grids/dynamic-grid.component";
import {ColumnDefinition} from "../../../fw/dynamic-grids/column-definition";
import {DtoTreatmentForCombi} from "./models/DtoTreatmentForCombi";
import {SharedValidators} from "../../shared/shared-validators";
import {ValidationMessageComponent} from "../../shared/validation-message.component";
import {DtoTreatmentCombination} from "./models/DtoTreatmentCombination";

@Component({
    selector: 'treatment-combination-search',
    template: require('./treatment-combination-search.component.html'),
    styles: [require('./treatment-combination-search.component.css')]
})
@AutoUnsubscribe()

export class TreatmentCombinationSearchComponent implements OnInit {
    @Input() dialog: DialogRef;
    @Output() treatmentChosen = new EventEmitter<DtoTreatmentForCombi>();
    @ViewChild('grid', {static: false}) grid: DynamicGridComponent;
    @ViewChild('validationMessage', {static: false}) validationMessage: ValidationMessageComponent;
    pageSubheaderBarConfig: PageSubheaderBarConfig;
    formSearch: FormGroup;
    formSelection: FormGroup;
    activeItems: Array<{ text: string, value: boolean }> = [
        { text: "Ja", value: true },
        { text: "Nee", value: false }
    ];
    columnDefinition: ColumnDefinition[] = [
        {
            key: 'index',
            label: 'Nummer',
            type: 'number',
            width: '110px'
        },
        {
            key: 'description',
            label: 'Omschrijving',
            type: 'string',
            width: '*'
        },
        {
            key: 'retailPrice',
            label: 'Prijs',
            type: 'number',
            width: '100px',
            format: '{0:c}'
        }
    ];
    selectedTreatment: DtoTreatmentForCombi;
    objectToEdit: DtoTreatmentCombination;

    constructor(private fb: FormBuilder,
                private fs: FormService,
                private ds: SettingsCashregService,
                private ss: SharedService) { }

    ngOnInit() {
        this.pageSubheaderBarConfig = {
            title: 'BEHANDELING',
            buttonDefinition: [
                {
                    clickEventType: 'choose',
                    description: 'KIEZEN',
                    isSmall: true
                },
                {
                    clickEventType: 'cancel',
                    description: 'ANNULEREN',
                    isSmall: true
                }
            ]
        };

        this.formSearch = this.fb.group({
            description: [''],
            index: [null]
        });

        this.formSelection = this.fb.group({
            retailPrice: [null, [SharedValidators.customNumberRequired]],
            treatmentTime: [null, [SharedValidators.customNumberRequired]]
        });

        this.formSelection.get('retailPrice').valueChanges.subscribe(newVal => {
            if (this.selectedTreatment) {
                this.selectedTreatment.retailPriceEx = this.ss.round(((newVal / (100 + this.selectedTreatment.btwPercentage)) * 100), 2);
            }
        });

        this.formSelection.valueChanges.subscribe(() => this.validationMessage.getFormValidationErrors());
        this.setObjectToEdit();
    }

    setObjectToEdit() {
        if (this.objectToEdit) {
            this.ds.getTreatmentForCombi({
                description: '',
                index: 0,
                id: this.objectToEdit.combinationTreatmentId
            }).subscribe(res => {
                this.grid.showData(res);
                if (res.length > 0) {
                    this.grid.setSelectedId(res[0].id);
                    this.selectedTreatment = res[0];
                    this.selectedTreatment.retailPrice = this.objectToEdit.retailPrice;
                    this.selectedTreatment.treatmentTime = this.objectToEdit.treatmentTime;
                    this.fs.patchDtoToForm(this.selectedTreatment, this.formSelection);
                }
            });
        }
    }

    btnClearClicked(event) {
        this.formSearch.reset();
        this.grid.showData([]);
    }

    btnSearchClicked(event) {
        this.ds.getTreatmentForCombi({
            description: this.formSearch.value.description,
            index: this.formSearch.value.index
        }).subscribe(res => {
            this.grid.showData(res);
        });
    }

    btnSubHeaderBarClicked(event) {
        if (event == 'choose') {
            if (this.selectedTreatment) {
                this.validationMessage.validateForm();
                if (this.formSelection.valid) {
                    let result = this.fs.patchFormToDto(this.selectedTreatment, this.formSelection);
                    if (this.objectToEdit) {
                        result.index = this.objectToEdit.index;
                    } else {
                        result.index = 0;
                    }
                    this.treatmentChosen.emit(result);
                    this.closeWindow(false);
                }
            }
        } else if (event == 'cancel') {
            this.closeWindow(false);
        }
    }

    rowDoubleClicked(event) {
        let chosenItem = this.grid.getSelectedItem();
        if (chosenItem) {
            this.validationMessage.validateForm();
            if (this.formSelection.valid) {
                if (this.objectToEdit) {
                    chosenItem.index = this.objectToEdit.index;
                } else {
                    chosenItem.index = 0;
                }
                this.treatmentChosen.emit(chosenItem);
                this.closeWindow(false);
            }
        }
    }

    gridSelectionChanged(event: DtoTreatmentForCombi) {
        this.selectedTreatment = event;
        this.fs.patchDtoToForm(this.selectedTreatment, this.formSelection);
    }

    closeWindow(result: boolean) {
        if (this.dialog) {
            this.dialog.dialog.instance.action.emit(result);
            this.dialog.close();
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/settings/settings-cashreg/treatment-combination-search.component.ts